export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const stats = [
    { label: '每日更新', value: '2000+' },
    { label: '内容频道', value: '50+' },
    { label: '稳定运行', value: '8年' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950"></div>
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url("https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20flowing%20gradient%20shapes%20in%20warm%20coral%20and%20deep%20charcoal%20tones%2C%20overlapping%20translucent%20layers%20suggesting%20digital%20media%20content%20flow%2C%20smooth%20organic%20curves%20intersecting%20with%20geometric%20grids%2C%20modern%20editorial%20design%20aesthetic%2C%20cinematic%20atmosphere%2C%20no%20text%20or%20typography%2C%20high%20contrast%20between%20light%20and%20dark%20areas&width=1400&height=800&seq=hero-bg-2026-01&orientation=landscape")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
              <span className="text-primary-300 text-xs font-medium whitespace-nowrap">内容聚合平台</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight text-balance">
              今日看料 · 精彩内容一站直达
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-300 font-heading">
              发现 · 收藏 · 分享 — 你的每日内容伴侣
            </p>

            <p className="mt-6 text-foreground-200 text-base md:text-lg leading-relaxed max-w-2xl mx-auto lg:mx-0">
              今日看料官网作为一站式内容导航平台，每日精选全网优质资源，覆盖影视娱乐、生活资讯、知识科普等多个频道。
              本站持续更新最新官方地址与首页入口，确保用户随时通过安全、稳定的导航直达品牌官网，畅享流畅的浏览体验。
              当前首页已同步最新内容合集，助你快速发现热门话题与精彩推荐。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-300 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-base hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索内容导航
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-base hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-full max-w-md aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20art%20composition%20with%20floating%20geometric%20shapes%20in%20warm%20coral%20orange%20and%20deep%20teal%20tones%2C%20layered%20translucent%20circles%20and%20rounded%20rectangles%20overlapping%20organically%2C%20smooth%20gradients%2C%20soft%20glow%20effects%2C%20contemporary%20editorial%20design%20style%2C%20clean%20minimal%20background%2C%20suggesting%20content%20discovery%20and%20media%20navigation%2C%20no%20text%20or%20letters&width=800&height=600&seq=hero-visual-2026-01&orientation=landscape"
                alt="今日看料内容聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}